import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import * as React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import { schemaFormActionValidate } from "../../../features/forms/schemas/schemaFormActionValidate";
import { isDev } from "../../../utils/dev";
import FieldTextArea from "../fields/FieldTextArea";
import FieldUpload from "../fields/FieldUpload/FieldUpload";
import FieldRadioButton from "../fields/FieldRadioButton";

export const formNameActionValidate = "form-action-validate";

export type FormActionValidateSchema = z.infer<typeof schemaFormActionValidate>;

type Props = {
  onSubmit: SubmitHandler<FormActionValidateSchema>;
};

const validateOrRefuseOptions = [
  {
    label: "Valider",
    value: "validate",
  },
  {
    label: "Refuser",
    value: "refused",
  },
];

const FormActionValidate: React.FC<Props> = ({ onSubmit }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormActionValidateSchema>({
    defaultValues: {
      validateOrRefuse: "validate",
    },
    resolver: zodResolver(schemaFormActionValidate),
  });

  if (isDev) {
    const formValues = watch(); // Get the form values state
    console.log("formValues", formValues);
    console.log("errors", errors);
  }

  return (
    <Form
      id={formNameActionValidate}
      onFinish={handleSubmit(onSubmit)}
      labelCol={{ span: 4 }}
    >
      <FieldRadioButton<FormActionValidateSchema>
        errorMessage={errors?.validateOrRefuse?.message}
        control={control}
        name="validateOrRefuse"
        options={validateOrRefuseOptions}
      />
      <FieldTextArea<FormActionValidateSchema>
        errorMessage={errors?.comment?.message}
        control={control}
        name="comment"
        label="Commentaire"
        placeholder="Commentaire..."
        isVertical
      />
      <FieldUpload<FormActionValidateSchema>
        errorMessage={errors.attachedFiles?.message}
        name="attachedFiles"
        control={control}
        listType="picture"
        label=""
        placeholder=""
      />
    </Form>
  );
};

export default FormActionValidate;
